import HttpService from "../services/http-service/HttpService";

const handleGenerateUrl = async (influencerId) => {
  try {
    // Construct the full URL
    const baseUrl = process.env.REACT_APP_BASE_URL; // Ensure this is set and not undefined
    if (!baseUrl) {
      throw new Error("Base URL is not defined in environment variables.");
    }

    const fullUrl = `${baseUrl}/checkavailability/${influencerId}`;

    // Send the URL to the backend to shorten
    const response = await HttpService.post(
      `${process.env.REACT_APP_API_URL}/api/shorten-url`, 
      { longUrl: fullUrl }
    );

    // Validate and return the shortened URL
    if (response.data && response.data.link) {
      return response.data.link;
    } else {
      throw new Error("Invalid response structure: Missing 'link' field.");
    }
  } catch (err) {
    console.error("Error generating Bitly URL:", err.message);
    throw err; // Re-throw the error for the caller to handle if needed
  }
};

export { handleGenerateUrl };
